import React, {useState, useEffect, useRef, Fragment} from "react";
import VariationCell from "./VariationCell";
import GLightbox from 'glightbox';
import axios from 'axios';
import animateScrollTo from 'animated-scroll-to';
import Bag from "../../icons/Bag";
import isLoggedIn from "../../../components/isLoggedIn";
import dispatch from "../../../components/dispatch";
import {ACTION_REGISTER_NOTIFICATION, ON_CART_UPDATE, ON_CELLS_PROCESSED} from "../../globals";
import ProductTile from "../../product-category/components/ProductTile";
import Close from "../../icons/Close";
import openCartPopup from "../../../components/openCartPopup";
import HoverPlus from "../../icons/HoverPlus";
import Loading from "../../icons/Loading";
import classNames from "classnames";
import CloseX from "../../icons/CloseX";
import Icon from "../../favourites/icons/Icon";
import AngleRight from "../../icons/AngleRight";
import FlickitySlider from "../../slider/slider";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Stockists from "../../stockists/component/Stockists";
import addressHTML, {HTML} from "../../../components/addressHTML";
import GetQuote from "./GetQuote";
import WarmthIndicator from "../../warmth-indicator/WarmthIndicator";
import isMainSite from "../../../components/isMainSite";
import useAxisLock from "./UseAxisLock";

const ProductPage = (props) => {
  const [image, setImage] = useState(null);
  const [modelImg, setModelImg] = useState(null);
  const [video, setVideo] = useState(null);
  const [imageOriginal, setImageOriginal] = useState(null);
  const [modelImgOriginal, setModelImgOriginal] = useState(null);
  const [images, setImages] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [grid, setGrid] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedQty, setSelectedQty] = useState(1);
  const [selectedVariations, setSelectedVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [notifyAbout, setNotifyAbout] = useState(null);
  const [email, setEmail] = useState('');
  const [isBulkAdding, setIsBulkAdding] = useState(false);
  const [showStockists, setShowStockists] = useState(false);
  const [showBackorder, setShowBackorder] = useState(false);
  const [showCartWarning, setShowCartWarning] = useState(false);
  const [embellishments, setEmbellishments] = useState([]);
  const [addedToBag, setAddedToBag] = useState(false);

  const [validations, setValidations] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [detailsOpened, setDetailsOpened] = useState(0);
  const [madeDetailsOpened, setMadeDetailsOpened] = useState(false);
  const [customizingDetailsOpened, setCustomisingDetailsOpened] = useState(false);
  const [variationImageCache, setVariationImageCache] = useState({});
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const [isETDMode, setIsETDMode] = useState(false);
  const [sizeChart, setSizeChart] = useState(false);
  const [getQuote, setGetQuote] = useState(false);
  const [orderSample, setOrderSample] = useState(false);
  const [activeSize, setActiveSize] = useState(null);
  const [quantity, setQuantity] = useState(1);


  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    setDetailsOpened(window.innerWidth > 768);
  };

  const handleSizeClick = (id) => {
    setActiveSize(id);
  };

  const handleGetQuote = () => {
    setGetQuote(true);
  };

  const closeGetQuotePopup = () => {
    setGetQuote(false);
  };

  const handleOrderSample = () => {
    setOrderSample(true);
  };

  const closeOrderSample = () => {
    setOrderSample(false);
  };

  const bulkOrder = useRef(null);
  const enquireBlock = useRef(null);

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (showBackorder) {
      const timeoutId = setTimeout(() => {
        setShowBackorder(false);
      }, 5000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [showBackorder]);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, [slider1, slider2, grid]);

  const totalItems = (image ? 1 : 0) + (modelImg ? 1 : 0) + (video && isDesktop ? 1 : 0) + images.length;

  const settings1 = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: totalItems > 1,
    fade: true,
    infinite: totalItems > 1,
    // responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       arrows: totalItems > 1
    //     }
    //   }
    // ]
  };

  const settings2 = {
    slidesToShow: 8,
    centerMode: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    vertical: true,
    verticalScroll: true,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerMode: false,
          arrows: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          vertical: false,
          centerMode: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          centerMode: false,
        }
      },
      {
        breakpoint: 580,
        settings: {
          vertical: false,
          arrows: false,
          centerMode: false,

        }
      },
      {
        breakpoint: 380,
        settings: {
          vertical: false,
          centerMode: false,
        }
      }
    ]
  };


  useEffect(() => {
    const product = props.product;

    const loadData = async () => {
      await loadImageData();
      await loadGridData();

      if (product.current_variation) {
        const color = product.colors.find(obj => obj.id === product.current_variation);
        selectColor(color);
      }
    };
    loadData();
  }, [props.product]);

  useEffect(() => {
    const updatePredicate = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", updatePredicate);

    return () => {
      window.removeEventListener("resize", updatePredicate);
    };
  }, []);

  useEffect(() => {
    if (props.product?.id && customizingDetailsOpened) {
      const loadEmbellishments = async () => {
        try {
          const response = await axios.get(`product/get-embellishments-data/${props.product.id}`);
          setEmbellishments(response.data);
        } catch (error) {
          console.error("Failed to load embellishments data:", error);
        }
      };
      loadEmbellishments();
    }
  }, [customizingDetailsOpened]);

  const loadGridData = async () => {
    const response = await axios.post(props.product.grid_link);
    const data = response.data;
    setGrid(data);
    stickyScroll();
  };

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url) {
        const img = new Image();
        img.style.position = 'absolute';
        img.style.left = '-50000px';
        img.style.top = '-50000px';
        img.onload = () => {
          resolve(url)
        }
        img.src = url;
      }
      return resolve(url)
    });
  }

  const loadImages = (img, imgO, model, modelO, video, images) => {
    loadImage(img)
      .then(() => {
        setImage(img);
        setImageOriginal(imgO)
        loadImage(model)
          .then(() => {
            setModelImg(model);
            setModelImgOriginal(modelO)
            setVideo(video);
            setImages(images);

            if (nav1) {
              nav1.slickGoTo(0)
            }
          });
      })
  }

  const loadImageData = async () => {
    const response = await axios.get(props.product.images_link);
    const data = response.data;
    setImageData(data);

    if (data.image) {

      loadImages(
        data.image,
        data.image_original,
        data.model_img,
        data.model_img_original,
        data.video,
        data.images && data.images.length ? data.images : []
      );
    }
  };

  const stickyScroll = () => {
    if (window.innerWidth <= 768) return; // Exit if screen width is less than or equal to 768px

    const siteHeader = document.querySelector('.js-header');
    const tableContents = document.querySelector('.summary-table__table');

    window.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        const table = document.querySelector('.table');
        const heading = document.querySelector('.table__head--sticky');

        const sR = siteHeader.getBoundingClientRect();
        const tR = table.getBoundingClientRect();
        const maxY = tR.height - sR.height - 100;

        let offset = sR.height - tR.y;
        if (offset > maxY) {
          offset = maxY;
        }
        if (offset <= 0) {
          offset = 0;
        }
        heading.style.top = offset + 'px';
      });
    });

    if (tableContents) {
      tableContents.addEventListener('scroll', (e) => {
        const thHSticky = tableContents.querySelectorAll('.table__c--sticky, .table__h--sticky');
        for (const c of thHSticky) {
          c.style.left = tableContents.scrollLeft + 'px';
        }
      });
    }
  };


  const initGLightbox = (e, index) => {
    e.preventDefault();

    const list = [];
    if (imageOriginal) {
      list.push({href: imageOriginal});
    }
    if (modelImgOriginal) {
      list.push({href: modelImgOriginal});
    }
    if (images) {
      images.map((img) => {
        list.push({href: img.original});
      });
    }

    const g = GLightbox({
      elements: list,
      startAt: index ? index : 0
    });
    g.open();
  };


  const selectColor = (color) => {
    const productImages = imageData;
    const variation = getVariationById(color.variation_id);

    window.history.pushState({id: variation.id}, '', variation.link);


    setSelectedColor(color.id);

    getVariationImagesById(color.variation_id).then((data) => {

      loadImages(
        data && data.image ? data.image : (productImages ? productImages.image : null),
        data && data.image_original ? data.image_original : (productImages ? productImages.image_original : null),
        data && data.model_img ? data.model_img : (productImages ? productImages.model_img : null),
        data && data.model_img_original ? data.model_img_original : (productImages ? productImages.model_img_original : null),
        data && data.video ? data.video : (productImages ? productImages.video : null),
        data && data.images && data.images.length ? data.images : (productImages ? productImages.images : [])
      );
    });
  };
  const addTime = (url) => {
    return url;
    // const t = Date.now();
    // return `${url}?t=${t}`;
  }

  const getVariationImagesById = (id) => {
    return new Promise((resolve, reject) => {
      if (typeof variationImageCache[id] !== 'undefined') {
        resolve(variationImageCache[id]);
      } else {
        axios.get(
          props.product.images_link,
          {
            params: {
              variation: id
            }
          }
        ).then((response) => {
          setVariationImageCache((prevCache) => ({
            ...prevCache,
            [id]: response.data
          }));
          resolve(response.data);
        });
      }
    });
  };

  const getVariationById = (id) => {
    const product = props.product;
    const variations = product.variations;
    for (const key of Object.keys(variations)) {
      const variation = variations[key];
      if (variation.id === id) {
        return variation;
      }
    }
    return null;
  };

  const findVariation = () => {
    if (selectedSize && selectedColor) {
      const product = props.product;
      const variations = product.variations;
      for (const key of Object.keys(variations)) {
        const variation = variations[key];
        if (
          variation.values.indexOf(selectedSize) >= 0
          && variation.values.indexOf(selectedColor) >= 0
        ) {
          return variation;
        }
      }
    }
    return null;
  };

  const selectedColorValue = () => {
    if (selectedColor) {
      const color = props.product.colors.filter((c) => c.id === selectedColor);
      return color.length ? color[0].value : null;
    }
    return null;
  };

  const addGroupToCart = async (e) => {
    e.preventDefault();
    const has = Object.keys(selectedVariations).length;
    if (has) {
      const validations = [];
      if (props.product.validation_message) {
        validations.push(props.product.validation_message);
      }

      for (const id in selectedVariations) {
        const variation = getVariationById(parseInt(id));
        if (variation && variation.validation_message) {
          validations.push(variation.validation_message);
        }
      }

      if (validations.length) {
        setValidations(validations);
      } else {
        processAddToGroup();
      }
    }
    return false;
  };

  const addToBag = () => {
    if (grid) {
      if (!selectedSize || !selectedColor || !selectedQty) {
        setShowCartWarning(true);
        return;
      }

      const variation = grid[`${selectedColor}__${selectedSize}`];
      setSelectedVariation(variation);
      setSelectedVariations(variation);
      updateVariationQuantity(variation, selectedQty);
      setShowBackorder(selectedQty > variation.full_stock);
      setShowCartWarning(false);
      setAddedToBag(true);

      setTimeout(() => {
        closeOrderSample();
      }, 1000);
    }


  };

  useEffect(() => {
    if (addedToBag) {
      processAddToGroup();
    }
  }, [addedToBag]);

  useEffect(() => {
    if (selectedSize && selectedColor && selectedQty) {
      setShowCartWarning(false);
    }
  }, [selectedSize, selectedColor, selectedQty]);

  const processAddToGroup = () => {
    setIsBulkAdding(true);

    axios.post('cart-api/add-group', selectedVariations)
      .then((response) => {
        const data = response.data;
        dispatch(ON_CART_UPDATE, data);
        dispatch(ON_CELLS_PROCESSED);

        setTimeout(() => {
          openCartPopup();
          setIsBulkAdding(false);
          setValidations([]);
          setAddedToBag(false);
        }, 20);
      });
  };

  const closeValidations = () => {
    setValidations([]);
  };

  const updateVariationQuantity = (variation, quantity) => {

    const selected = {...selectedVariations};
    if (quantity) {
      selected[variation.id] = quantity;
    } else {
      delete selected[variation.id];
    }
    setSelectedVariations(selected);
  };

  const renderCellFor = (color, size, sizeValue, tabIndex) => {
    if (grid) {
      const key = `${color}__${size}`;
      const variation = grid[key];
      if (variation) {
        return (
          <VariationCell
            etdMode={isETDMode}
            variation={variation}
            tabIndex={tabIndex}
            quantity={selectedVariations[variation.id] || 0}
            addGroupToCart={addGroupToCart}
            updateVariationQuantity={updateVariationQuantity}
            parent={ProductPage}
            size={sizeValue}
          />
        );
      }
    }
    return '';
  };

  const closeNotification = () => {
    setNotifyAbout(null);
  };

  const registerNotification = (e) => {
    e.preventDefault();
    axios.post(ACTION_REGISTER_NOTIFICATION, {
      'email': email,
      'variation': notifyAbout.id
    }).then(() => {
      closeNotification();
    });
    return false;
  };

  const scrollToBulk = (e) => {
    e.preventDefault();
    const table = bulkOrder.current;
    if (table) {
      const rect = table.offsetTop - 150;
      animateScrollTo(rect).then(hasScrolledToPosition => {
      });
    }
    return false;
  };

  const scrollToEnquire = (e) => {
    e.preventDefault();
    setShowStockists(true);
    window.setTimeout(() => {
      const table = enquireBlock.current;
      if (table) {
        const rect = table.offsetTop - 150;
        animateScrollTo(rect).then(hasScrolledToPosition => {
        });
      }
    }, 100);
    return false;
  };

  const product = props.product;
  const loggedIn = isLoggedIn();
  const mainSite = isMainSite();
  const selected_variations = Object.keys(selectedVariations).length > 0;
  const colorValue = selectedColorValue();

  return <Fragment>
    <div className="product-page__content">

      <div className="product-page__image-grid">
        <div className="product-grid">
          <div className='product-grid__slider'>
            {grid && <>
              <div className="slider1">
                <Slider {...settings1} asNavFor={nav2} ref={slider1}>
                  {image && <div className="product-grid__item">
                    <a
                      href={addTime(imageOriginal)}
                      onClick={(e) => {
                        initGLightbox(e, 0)
                      }}
                      target="_blank"
                      data-gallery="product"
                      className="product-grid__item-align">
                      <div className="product-grid__image">
                        <img src={addTime(image)} alt={product.title}/>
                      </div>
                      <div className="product-grid__item-hover">
                        <HoverPlus/>
                      </div>
                    </a>
                  </div>}
                  {modelImg && <div className="product-grid__item">
                    <a
                      href={addTime(modelImgOriginal)}
                      onClick={(e) => {
                        let start = (image ? 1 : 0);
                        initGLightbox(e, start)
                      }}
                      target="_blank"
                      data-gallery="product"
                      className="product-grid__item-align">
                      <div className="product-grid__image">
                        <img src={addTime(modelImg)} alt={product.title}/>
                      </div>
                      <div className="product-grid__item-hover">
                        <HoverPlus/>
                      </div>
                    </a>
                  </div>}
                  {(video && isDesktop) && <div className="product-grid__item">
                    <a
                      href={addTime(video)}
                      target="_blank"
                      data-gallery="product"
                      className="product-grid__item-align">
                      <div className="product-grid__image">
                        <video src={addTime(video)} preload="auto" autoPlay={1} muted={1} loop={1} playsInline=""/>
                      </div>
                      <div className="product-grid__item-hover">
                        <HoverPlus/>
                      </div>
                    </a>
                  </div>}
                  {images.length > 0 &&
                  images.map((img, index) => (
                    <div className="product-grid__item" key={`img__${img.id}`}>
                      <a
                        href={addTime(img.original)}
                        onClick={(e) => {
                          let start = index;
                          if (image) {
                            start += 1;
                          }
                          if (modelImg) {
                            start += 1;
                          }
                          initGLightbox(e, start)
                        }}
                        target="_blank"
                        data-gallery="product"
                        className="product-grid__item-align">
                        <div className="product-grid__image">
                          <img src={addTime(img.url)} alt={product.title}/>
                        </div>
                        <div className="product-grid__item-hover">
                          <HoverPlus/>
                        </div>
                      </a>
                    </div>
                  ))}
                </Slider>
              </div>
              <div className={`slider2 ${totalItems < 8 ? "few-slides" : ""}`}>
                <Slider {...settings2} asNavFor={nav1} ref={slider2}>
                  {image && (
                    <div className="product-grid__item">
                      <div target="_blank" className="product-grid__item-align">
                        <div className="product-grid__image" style={{backgroundImage: `url("${image}")`}}/>
                      </div>
                    </div>
                  )}
                  {modelImg && (
                    <div className="product-grid__item">
                      <div target="_blank" className="product-grid__item-align">
                        <div className="product-grid__image" style={{backgroundImage: `url("${modelImg}")`}}/>
                      </div>
                    </div>
                  )}
                  {(video && isDesktop) && (
                    <div className="product-grid__item">
                      <div target="_blank" className="product-grid__item-align">
                        <div className="product-grid__image">
                          <video src={video} preload="auto" autoPlay={1} muted={1} loop={1} playsInline=""/>
                        </div>
                      </div>
                    </div>
                  )}
                  {images.length > 0 &&
                  images.map((img) => (
                    <div className="product-grid__item" key={`img__${img.id}`}>
                      <div target="_blank" className="product-grid__item-align">
                        <div className="product-grid__image" style={{backgroundImage: `url("${img.url}")`}}/>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </>}
          </div>

        </div>
        {isDesktop && (
          <div className="product-page__sizeChart--desktop">
            {!grid && (
              <div className={'summary-table__loading'}>
                <Loading/>
              </div>)
            }
            {!!grid && (
              <div className="summary-table" ref={bulkOrder}>
                <div className="summary-table__title">
                  {product.enabled_cart && (
                    <h2 className="h4">
                      {loggedIn ? (
                        <span>Inventory - overtype to order</span>
                      ) : (
                        <span> Inventory{' '}
                          {!product.is_skinned_site && (
                            <small>
                              (<a href={product.login_link}>Login to order</a>)
                            </small>
                          )}
                        </span>
                      )}
                    </h2>
                  )}


                  <h4>
                    <label
                      htmlFor={'due-2'}>
                      <input
                        id={'due-2'}
                        type={'checkbox'}
                        checked={isETDMode}
                        onChange={() => {
                          setIsETDMode(!isETDMode)
                        }}
                      />
                      Show due dates
                    </label>
                  </h4>
                </div>
                <div className="summary-table__table-container">

                  <div className="summary-table__table">
                    <div className={'table table--stick-header'}>
                      <div className={'table__row table__head  table__head--sticky'}>
                        <div className={'table__h table__h--sticky'}>Colour</div>
                        {product.sizes.map((size) => (
                          <div className={'table__h'} key={`t_size_${size.id}`}>
                            <span>{size.value}</span>
                          </div>
                        ))}
                      </div>
                      {product.colors.map((color, index) => {
                        return <div className={`table__row table__row--${index}`} key={`t_row_${color.id}`}>
                          <div className={'table__c table__c--sticky'}>
                            <div className="color-item">
                                  <span className="color" style={{
                                    borderColor: color.color === 'FFFFFF' && !color.color_icon ? '#000000' : null,
                                    backgroundColor: `#${color.color}`,
                                    backgroundImage: color.color_icon ? `url("${color.color_icon}")` : null
                                  }}></span> {color.value}
                            </div>
                          </div>
                          {product.sizes.map((size) => (
                            <div key={`t_cell_${size.id}`} className={classNames({
                              'in-active': !grid[`${color.id}__${size.id}`]?.can_purchase,
                              'table__c': true
                            })}>
                              {renderCellFor(color.id, size.id, size.value)}
                            </div>
                          ))}
                        </div>
                      })}
                    </div>
                  </div>
                  {selected_variations && (

                    <div className="summary-table__btn-wrapper">
                      <span className="btn btn--uppercase btn--not-bg-icon btn--red" onClick={addGroupToCart}>
                        {isBulkAdding && <Loading/>}
                        {!isBulkAdding && <Fragment> Add to cart</Fragment>}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

      </div>
      <div className="product-details__header product-details__header--mobile">
        <div className="product-details__title">
          {!!product.custom_1013 && <p className="product-details__type">{product.custom_1013}</p>}
          <h1>{product.title}</h1>
          {!!product.style && <h6 className="product-details__style">Style <span>{product.style}</span></h6>}
          <span className="product-details__favorite">
                <Icon product={product.id} lock={product.lockShare}/>
            </span>
        </div>

        {loggedIn && product.price_columns.length > 0 && (
          <table className="product-details__price-columns">
            <tbody>
            {product.price_columns.map((price_column, index) => {
              if (price_column.title || price_column.label) {
                return (
                  <tr key={index}>
                    <td>{price_column.title || price_column.label}</td>
                    <td>{price_column.price} {!product.tax_exempted && <span>+ GST</span>}</td>
                  </tr>
                );
              }
              return null;
            })}
            </tbody>
          </table>
        )}

        {!!loggedIn && product.is_au_site &&
        <p className="product-details__price">{product.price}{!product.is_au_site && <span>+ GST</span>}</p>}
        {!loggedIn && product.enabled_cart && !product.is_skinned_site &&
        <p className="product-details__login-text"><a href={product.login_link}>login</a> for wholesale pricing</p>}
      </div>
      <div className="product-page__details product-details">
        <div className="product-details__header">
          <div className="product-details__title">
            {!!product.custom_1013 && <p className="product-details__type">{product.custom_1013}</p>}
            <h1>{product.title}</h1>
            {!!product.style && <h6 className="product-details__style">Style <span>{product.style}</span></h6>}
            <span className="product-details__favorite">
                  <Icon product={product.id} lock={product.lockShare}/>
                  </span>
          </div>

          {loggedIn && product.price_columns.length > 0 && (
            <table className="product-details__price-columns">
              <tbody>
              {product.price_columns.map((price_column, index) => {
                if (price_column.title || price_column.label) {
                  return (
                    <tr key={index}>
                      <td>{price_column.title || price_column.label}</td>
                      <td>{price_column.price} {(!product.tax_exempted && !product.is_au_site) &&
                      <span>+ GST</span>}</td>
                    </tr>
                  );
                }
                return null;
              })}
              </tbody>
            </table>
          )}

          {!loggedIn && product.is_au_site &&
          <p className="product-details__price">{product.price}{!product.is_au_site && <span>+ GST</span>}</p>}
          {!loggedIn && product.enabled_cart && !product.is_skinned_site &&
          <p className="product-details__login-text"><a href={product.login_link}>login</a> for wholesale pricing</p>}
        </div>

        {product.colors.length > 0 && (
          <div className="product-details__colors">
            {!!colorValue && <h6 className="product-details__title-sm">Colour: {colorValue}</h6>}
            {!colorValue && <h6 className="product-details__title-sm">Select Colour</h6>}
            <ul>
              {product.colors.map((color) => (
                <li
                  className={`product-details__color ${selectedColor === color.id ? ' active' : ''}`}
                  key={`color__${color.id}`}
                  tabIndex={0}
                  onFocus={() => {
                    selectColor(color);
                  }}
                  onClick={() => {
                    selectColor(color);
                  }}
                  title={color.value}
                  style={{
                    borderColor: color.color === 'FFFFFF' && !color.color_icon ? '#c4c4c4' : null,
                    backgroundColor: `#${color.color}`,
                    backgroundImage: color.color_icon ? `url("${color.color_icon}")` : null,
                  }}
                />
              ))}
            </ul>
          </div>
        )}

        {product.sizes.length > 0 && (
          <div className="product-details__sizes">
            <div className="product-details__links">
              {(loggedIn || product.enabled_retail_order) ? (<table>
                <tr>
                  <td className="product-details__heading">
                    <h6 className="product-details__title-sm">SIZE</h6>

                  </td>

                </tr>
                <tr>
                  <td>
                    <ul className={'product-details__size-list'}>
                      {product.sizes.map((size) => {
                        const key = selectedColor ? `${selectedColor}__${size.id}` : null;
                        const isDisabled = key && grid && grid[key] ? !grid[key].can_purchase : false;

                        return (
                          <li key={size.id} className={(!isDisabled && (loggedIn || product.enabled_retail_order)) ? 'clickable' : ''}>
                            <div
                              className={`size-btn ${
                                activeSize === size.id && (loggedIn || product.enabled_retail_order) ? 'active' : ''
                              }`}
                              style={{
                                backgroundColor: isDisabled ? '#f5f5f5' : null,
                                border: isDisabled ? '1px solid #dcdcdc' : null,
                                color: isDisabled ? '#b0b0b0' : null,
                              }}
                              onClick={() => {
                                if (!isDisabled) {
                                  handleSizeClick(size.id);
                                  setSelectedSize(size.id);
                                }
                              }}
                            >
                              {size.value}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </td>
                </tr>
                <tr>
                {!!product.size_chart && (!product.is_au_site || (product.is_au_site && loggedIn)) && ( <a
                      onClick={(e) => {
                        e.preventDefault();
                        setSizeChart(true)
                        return false;
                      }}
                      className="link link--underline link--viewSite">
                      View size chart
                    </a>)}
                </tr>
              </table>) : null}

              <div>
                {!loggedIn && !product.enabled_retail_order &&
                <>
                  <h6 className="product-details__title-sm">SIZE</h6>
                  <ul className={'product-details__size-list'}>
                    {product.sizes.map((size) => (
                      <li key={size.id}>
                        <span>{size.value}</span>
                      </li>
                    ))}
                  </ul>
                </>
                }
                <div className={'no-border multi-links'}>
                  {(!loggedIn) ? (<>
                    {!!product.size_chart && <a
                      onClick={(e) => {
                        e.preventDefault();
                        setSizeChart(true)
                        return false;
                      }}
                      className="link link--underline">
                      View size chart
                    </a>}
                  </>) : null}

                  {!!product.custom_1012 && <a
                    target={'_blank'}
                    href={product.custom_1012}
                    className="link link--underline"
                  >
                    View other sizes in this style
                  </a>}
                </div>
              </div>
            </div>
          </div>
        )}

        <h6 className="product-details__order-entry">
          {(!!loggedIn || product?.enabled_retail_order) ? (<>
            {!!showBackorder && (
              <div className={'backorder'} style={{position: 'absolute'}}>
                <div className={'backorder__close'} onClick={() => setShowBackorder(false)}>
                  <CloseX/>
                </div>
                <div className={'backorder__inner'}>{selectedVariation.full_stock} in stock. Balance will be backordered.
                </div>
              </div>
            )}
            {!!showCartWarning && (
              <div className={'backorder'} style={{position: 'absolute'}}>
                <div className={'backorder__close'} onClick={() => setShowCartWarning(false)}>
                  <CloseX/>
                </div>
                <div className="backorder__inner">
                  Please select{' '}
                  {[
                    !selectedColor && 'colour',
                    !selectedSize && 'size',
                    !selectedQty && 'quantity',
                  ]
                    .filter(Boolean)
                    .join(', ')
                    .replace(/, ([^,]*)$/, ' & $1')
                    .toLowerCase()}
                  .
                </div>
              </div>
            )}
            <input id={'add-to-bag'} type={'number'} min={0} defaultValue={1} onChange={(e) => {
              setSelectedQty(e.target.value)
            }}/>
            <button onClick={addToBag} className="btn btn--black add-to-bag">
              <span>Add to bag</span>
            </button>
          </>) : null}
        </h6>

        {product.custom_1004 > 0 && <WarmthIndicator indicator_value={product.custom_1004} />}

        <div class="product-details__btnsWrap">
          {!product.is_au_site && !loggedIn && <div className="product-details__btn">
            {/* <h6
              className={`product-details__title-sm product-details__title-normal`}
            >
              Pricing / How To Order
            </h6> */}
            <div className="typography">
              {/* {mainSite ? (
                <p>To get a quote, fill out the form below.
                  One of our distributors will then contact you with pricing.
                  You can then liaise them directly about your branding requirements and order
                  through them.</p>
              ) : (
                <p>To get a quote, fill out the form below, and we'll come back to you with pricing all-inclusive of
                  garments and branding.</p>
              )} */}
              <div>
                <button className="btn btn--black" onClick={() => handleGetQuote()}>Enquire</button>
              </div>
            </div>
          </div>}
          {product?.enabled_sample_order && <div className="product-details__btn">
            <div>
              <button className="btn btn--black" onClick={() => handleOrderSample()}>Order Sample</button>
            </div>
          </div>}
        </div>

        {!!product.custom_1007 && (
          <div className={'product-details__info-block'}>
            <p dangerouslySetInnerHTML={{__html: product.custom_1007}}/>
          </div>
        )}


        {!!(product.description || product.infosheet || product.custom_1008 || product.shipping_restrictions) && (
          <div className="product-details__details">
            <h6
              className={`product-details__title-sm product-details__title-acc ${detailsOpened ? 'active' : ''}`}
              onClick={() => {
                setDetailsOpened(!detailsOpened);
                setMadeDetailsOpened(false);
                setCustomisingDetailsOpened(false);
              }}
            >
              Details
              <span>
                <AngleRight/>
              </span>
            </h6>
            {!!detailsOpened && (
              <div className="typography product-details__typography">
                <div dangerouslySetInnerHTML={{__html: product.description}}/>

                {!!product.infosheet && (
                  <div className={'product-details__link-container'}>
                    <p>
                      <a href={product.infosheet} download={true}>
                        Download info sheet
                      </a>
                    </p>
                  </div>
                )}
                {!!product.custom_1008 && (
                  <div className={'product-details__link-container'}>
                    <p>
                      <a href={product.custom_1008} target={'_blank'}>
                        View additional images
                      </a>
                    </p>
                  </div>
                )}
                {!!product.shipping_restrictions && (
                  <div className={'product-details__link-container'}>
                    <p>
                      <a href={product.shipping_restrictions} target={'_blank'}>
                        Shipping restrictions and duties may apply
                      </a>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {!!product.custom_1016 && (
          <div className="product-details__details">
            <h6
              className={`product-details__title-sm product-details__title-acc ${madeDetailsOpened ? 'active' : ''}`}
              onClick={() => {
                setDetailsOpened(false);
                setMadeDetailsOpened(!madeDetailsOpened);
                setCustomisingDetailsOpened(false);
              }}
            >
              How this was made
              <span>
                <AngleRight/>
              </span>
            </h6>
            {!!madeDetailsOpened && (
              <div className="typography product-details__typography">
                <div dangerouslySetInnerHTML={{__html: product.custom_1016}}/>
              </div>
            )}
          </div>
        )}
        {!!product.custom_1015 && (
          <div className="product-details__details">
            <h6
              className={`product-details__title-sm product-details__title-acc ${customizingDetailsOpened ? 'active' : ''}`}
              onClick={() => {
                setDetailsOpened(false);
                setMadeDetailsOpened(false);
                setCustomisingDetailsOpened(!customizingDetailsOpened);
              }}
            >
              Embellishment / Customising
              <span>
                <AngleRight/>
              </span>
            </h6>
            {!!customizingDetailsOpened && embellishments.length > 0 && (
              <div className="typography product-details__typography">
                <div dangerouslySetInnerHTML={{__html: product.custom_1015}}/>
                <div className="product-details__embellishment">
                  {/* <div className="product-details__embellishment__title">
                    <p>This garment can be branded with the following method</p>
                  </div> */}
                  <div className="product-details__embellishment__holder">

                    {embellishments.map((embellishment) => (
                      <div className="product-details__embellishment__image" key={embellishment.id}>
                        <img src={customizingDetailsOpened ? embellishment.image_url : ''} alt="embellishment"/>
                        <p>{embellishment.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}


        {product.icons.length > 0 && (
          <ul className="product-details__logos">
            {product.icons.map((icon, index) => (
              <li key={`icon__${index}`}>
                {!!icon.url && <a href={icon.url} target="_blank"><img src={icon.image} width={64}/></a>}
                {!icon.url && <img src={icon.image} width={64}/>}
              </li>
            ))}
          </ul>
        )}

      </div>
    </div>
    {!isDesktop && (
      <div className="product-page__sizeChart--mobile">
        {!grid && (
          <div className={'summary-table__loading'}>
            <Loading/>
          </div>)
        }
        {!!grid && (
          <div className="summary-table" ref={bulkOrder}>
            <div className="summary-table__title">
              <h2
                className="h4 summary-table__title"
                dangerouslySetInnerHTML={{
                  __html: loggedIn
                    ? 'Inventory - overtype to order'
                    : `<span>Inventory ${
                      !product.is_skinned_site
                        ? `<small>(<a href="${product.login_link}">Login to order</a>)</small>`
                        : ''
                    }</span>`,
                }}
              />
              <h4>
                <label htmlFor={'due-1'}>
                  <input
                    id={'due-1'}
                    type={'checkbox'}
                    checked={isETDMode}
                    onChange={() => {
                      setIsETDMode(!isETDMode)
                    }}
                  />
                  Show due dates
                </label>
              </h4>
            </div>
            <div className="summary-table__table-container">
              <div className="summary-table__table" style={{overflow: "auto"}}>
                <div className={'table table--stick-header'}>
                  <div className={'table__row table__head  table__head--sticky'}>
                    <div className={'table__h table__h--sticky'}>Colour</div>
                    {product.sizes.map((size) => (
                      <div className={'table__h'} key={`t_size_${size.id}`}>
                        <span>{size.value}</span>
                      </div>
                    ))}
                  </div>
                  {product.colors.map((color, index) => {
                    return <div className={`table__row table__row--${index}`} key={`t_row_${color.id}`}>
                      <div className={'table__c table__c--sticky'}>
                        <div className="color-item">
                              <span className="color" style={{
                                borderColor: color.color === 'FFFFFF' && !color.color_icon ? '#000000' : null,
                                backgroundColor: `#${color.color}`,
                                backgroundImage: color.color_icon ? `url("${color.color_icon}")` : null
                              }}></span> {color.value}
                        </div>
                      </div>
                      {product.sizes.map((size) => (
                        <div key={`t_cell_${size.id}`} className={classNames({
                          'in-active': !grid[`${color.id}__${size.id}`]?.can_purchase,
                          'table__c': true
                        })}>
                          {renderCellFor(color.id, size.id, size.value)}
                        </div>
                      ))}
                    </div>
                  })}
                </div>
              </div>
              {selected_variations && (

                <div className="summary-table__btn-wrapper">
                  <span className="btn btn--uppercase btn--not-bg-icon" onClick={addGroupToCart}>
                    {isBulkAdding && <Loading/>}
                    {!isBulkAdding && <Fragment><Bag/> Add to cart</Fragment>}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="product-page__addToCartBtn">
          <button className="btn btn--red">Add To Cart</button>
        </div>
      </div>
    )}

    {!loggedIn && (
      <div ref={enquireBlock}>
        {/* <div className="enquire-product__title">
          <p>
            CLOKE garments are available through our distributor network; NZ’s
            best garment branders.
            View distributors <a href={'#'}
                                 data-ge={'enquire_button'}
                                 data-name={product.title} onClick={scrollToEnquire}>here</a>, or <a
            href={'/about/contact'}>click here</a> to contact CLOKE direct.
          </p>

        </div> */}
        {showStockists && <Stockists
          productid={product.id}
          product={`${product.title} - ${product.style}`}/>}
      </div>
    )}
    {product.related.length > 0 && (
      <div className="related-products">
        <h2 className="h5 summary-table__title">You may also like</h2>
        <div className="related-products__grid">
          {product.related.map((relatedProduct) => (
            <ProductTile key={`related_${relatedProduct.id}`} product={relatedProduct}/>
          ))}
        </div>
        <div className="related-products__slider">
          <FlickitySlider
            options={{
              adaptiveHeight: true,
              prevNextButtons: false,
              pageDots: false,
              contain: true
            }}
          >
            {product.related.map((relatedProduct) => (
              <ProductTile key={`related_${relatedProduct.id}`} product={relatedProduct}/>
            ))}
          </FlickitySlider>
        </div>
      </div>
    )}
    {notifyAbout !== null && (
      <div className="stock-popup">
        <div className="container-">
          <div className="wrapper">
              <span className="stock-popup__close" onClick={closeNotification}>
              <Close/>
              </span>
            <h3 className="h4 stock-popup__title">Request back in-stock notification</h3>
            <div className="typography stock-popup__typography">
              <p>Leave your email address below and we'll let you know when this item is back in stock.</p>
            </div>
            <div className="stock-popup__form">
              <form onSubmit={registerNotification}>
                <fieldset>
                  <div className="field text">
                    <label className="left">Email</label>
                    <div className="middleColumn">
                      <input
                        type="email"
                        required={true}
                        name="name"
                        className="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email Address"
                      />
                    </div>
                  </div>
                </fieldset>
                <div className="Actions">
                  <button className="action btn" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )}
    {validations.length > 0 && (
      <div className={"product-page__validations"}>
        <div className={'product-page__validations-content'}>
          <div className={'product-page__validations-inner'}>
            <div
              className={'product-page__validations-close'}
              onClick={closeValidations}
            >
              <CloseX/>
            </div>
            <div className={'product-page__validations-body'}>
              {validations.map((message, index) => (
                <div
                  className={'typography'}
                  key={index}
                  dangerouslySetInnerHTML={{__html: message}}
                />
              ))}
            </div>
            <div className={'product-page__validations-action'}>
              <button
                onClick={processAddToGroup}
                className={'btn btn--uppercase btn--not-bg-icon'}
              >
                {isBulkAdding ? <Loading/> : `Continue`}
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {!!product.size_chart && <Lightbox
      open={sizeChart}
      close={() => {
        setSizeChart(false)
      }}
      slides={[
        {
          src: product.size_chart
        }
      ]}
    />}

    {getQuote && <GetQuote product={product} closePopup={closeGetQuotePopup}/>}

    {orderSample && <>
      <div className="orderSample">
        <div className="orderSample__wrap">
          <div className="orderSample__title">
            <h2>Order Sample</h2>
            <button className="close-btn" onClick={() => closeOrderSample()}><CloseX/></button>
          </div>
          <div className="orderSample__intro">
            <h6>SAMPLES-FAST, EASY, RISK-FREE</h6>
            <p>You may wish to checkout a sample before committing to a bulk order.
              Is it good quality? Does it feel nice and soft? is it the right warmth?
              Is the sizing like I expect?</p>
            <p>We get it! So we offer an Easy Sample service to take away the risk factor.
              And it's fast: Order by 4pm and we'll courier that same business day.</p>
          </div>
          <div className="orderSample__form">
            <div className="product-details__header product-details__header--both">
              <div className="product-details__title">
                <h1>{product.title}</h1>
                {!!product.style && <h6>Style <span>{product.style}</span></h6>}
              </div>

              <table className="product-details__price-columns">
                <div><p>Blank sample price: {product.price} {!product.tax_exempted && <span>+ GST</span>}, freight free</p></div>
                <div><p>Click <a onClick={handleGetQuote}>here</a> to get a quote for bulk quantities and/or branded garments.</p></div>
              </table>

            </div>
            {product.colors.length > 0 && (
              <div className="product-details__colors">
                {!!colorValue && <h6 className="product-details__title-sm">Colour: {colorValue}</h6>}
                {!colorValue && <h6 className="product-details__title-sm">Select Colour</h6>}
                <ul>
                  {product.colors.map((color) => (
                    <li
                      className={`product-details__color ${selectedColor === color.id ? ' active' : ''}`}
                      key={`color__${color.id}`}
                      tabIndex={0}
                      onFocus={() => {
                        selectColor(color);
                      }}
                      onClick={() => {
                        selectColor(color);
                      }}
                      title={color.value}
                      style={{
                        borderColor: color.color === 'FFFFFF' && !color.color_icon ? '#c4c4c4' : null,
                        backgroundColor: `#${color.color}`,
                        backgroundImage: color.color_icon ? `url("${color.color_icon}")` : null,
                      }}
                    />
                  ))}
                </ul>
              </div>
            )}
            {product.sizes.length > 0 && (
              <div className="product-details__sizes">
                <div className="product-details__links">
                  <h6 className="product-details__heading">
                    Select Size
                  </h6>
                  <table>
                    <tr>
                      <td>
                        <ul className={'product-details__size-list'}>
                          {product.sizes.map((size) => {
                              const key = selectedColor ? `${selectedColor}__${size.id}` : null;
                              const isDisabled = key && grid && grid[key] ? !grid[key].can_purchase : false;
                              return (
                                <li key={size.id} className={!isDisabled ? 'clickable' : ''}>
                                  <div
                                    className={`size-btn ${activeSize === size.id ? 'active' : ''}`}
                                    style={{
                                      backgroundColor: isDisabled ? '#f5f5f5' : null,
                                      border: isDisabled ? '1px solid #dcdcdc' : null,
                                      color: isDisabled ? '#b0b0b0' : null,
                                      marginBottom: isDisabled ? '8px' : null,
                                    }}
                                    onClick={(e) => {
                                      if (!isDisabled) {
                                        handleSizeClick(size.id);
                                        setSelectedSize(size.id);
                                      }
                                    }}
                                  >
                                    {size.value}
                                  </div>
                                </li>
                                );
                          })}
                        </ul>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            )}

            {!!showBackorder ? (
              <p className="warning">{selectedVariation.full_stock} in stock. Balance will be backordered.</p>) : ''}
            {!!showCartWarning && (<p className="warning">
              Please select{' '}
              {[
                !selectedColor && 'colour',
                !selectedSize && 'size',
                !selectedQty && 'quantity',
              ]
                .filter(Boolean)
                .join(', ')
                .replace(/, ([^,]*)$/, ' & $1')
                .toLowerCase()}
              .
            </p>)}

            <div className="product-details__add-bag">
              <input
                id="quantity"
                type="number"
                value={1}
                min="1"
                disabled
                // onChange={setSelectedQty(1)}
              />

              <button onClick={addToBag} className="btn btn--black">
                Add to Bag
              </button>
            </div>

            <p className="orderSample__info">Max 1 garment per style/colour/size</p>

          </div>
        </div>
      </div>
    </>}

  </Fragment>

};

export default ProductPage;
